import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-bold text-lg" }
const _hoisted_2 = { class: "flex flex-col h-full" }
const _hoisted_3 = { class: "flex-1 overflow-y-auto pr-2 pb-24" }
const _hoisted_4 = { class: "absolute bottom-0 left-0 right-0 p-4 bg-white border-t border-neutral-200 flex gap-3" }

import { computed } from 'vue'
import Sidebar from 'primevue/sidebar'
import Button from 'primevue/button'


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterSidebar',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: 'Filter'
  }
},
  emits: ['update:modelValue', 'apply'],
  setup(__props, { emit }) {

const props = __props





const internalVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const applyFilter = () => {
  emit('apply')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Sidebar), {
    visible: _unref(internalVisible),
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(internalVisible) ? (internalVisible).value = $event : null)),
    position: "right",
    class: "filter-sidebar"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Button), {
            label: "Kembali",
            class: "p-button-outlined text-neutral-700 border-neutral-300 w-1/2 justify-center",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (internalVisible.value = false))
          }),
          _createVNode(_unref(Button), {
            label: "Simpan",
            class: "bg-blue-500 border-blue-500 text-white w-1/2 justify-center",
            onClick: applyFilter
          })
        ])
      ])
    ]),
    _: 3
  }, 8, ["visible"]))
}
}

})